export default [
  {
    name: "Tickets",
    path: "/tickets"
  },
  {
    name: "TicketProfile",
    path: "/ticket/:id"
  }
];
